// src/components/InvestmentsTable.js
import React, { useEffect, useState } from "react";
import { fetchData, updateInvestment } from "../utilities/api";

const InvestmentsTable = () => {
	const [investments, setInvestments] = useState([]);
	const [editForm, setEditForm] = useState(null);

	const loadInvestments = async () => {
		try {
			const { investments } = await fetchData();
			setInvestments(investments);
		} catch (error) {
			console.error("Error loading investments:", error);
		}
	};

	const handleEdit = (investment) => {
		setEditForm(investment);
	};

	const handleSave = async (e) => {
		e.preventDefault();
		try {
			await updateInvestment(editForm.timestamp, editForm);
			loadInvestments();
			setEditForm(null);
		} catch (error) {
			console.error("Error updating investment:", error);
		}
	};

	useEffect(() => {
		loadInvestments();
	}, []);

	return (
		<div className="p-6">
			<h1 className="text-2xl font-bold mb-4">Investments</h1>
			<table className="w-full border-collapse">
				<thead>
					<tr>
						<th className="border px-4 py-2">Date</th>
						<th className="border px-4 py-2">Type</th>
						<th className="border px-4 py-2">Units</th>
						<th className="border px-4 py-2">Amount</th>
						<th className="border px-4 py-2">Actions</th>
					</tr>
				</thead>
				<tbody>
					{investments.filter((item => item.units > 0)).map((investment) => (
						<tr key={investment.timestamp}>
							<td className="border px-4 py-2">{investment.date}</td>
							<td className="border px-4 py-2">{investment.type}</td>
							<td className="border px-4 py-2">{investment.units}</td>
							<td className="border px-4 py-2">
								{investment.amount.toFixed(2)}
							</td>
							<td className="border px-4 py-2">
								<button
									onClick={() => handleEdit(investment)}
									className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
								>
									Edit
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>

			{editForm && (
				<form onSubmit={handleSave} className="mt-6">
					<h2 className="text-xl font-bold mb-4">Edit Investment</h2>
					<div className="mb-4">
						<label>Date</label>
						<input
							type="date"
							value={editForm.date}
							onChange={(e) =>
								setEditForm({ ...editForm, date: e.target.value })
							}
							className="border rounded px-3 py-2"
						/>
					</div>
					<div className="mb-4">
						<label>Type</label>
						<select
							value={editForm.type}
							onChange={(e) =>
								setEditForm({ ...editForm, type: e.target.value })
							}
							className="border rounded px-3 py-2"
						>
							<option value="gold">Gold</option>
							<option value="apple">Apple</option>
							<option value="google">Google</option>
						</select>
					</div>
					<div className="mb-4">
						<label>Units</label>
						<input
							type="number"
							value={editForm.units}
							onChange={(e) =>
								setEditForm({ ...editForm, units: e.target.value })
							}
							className="border rounded px-3 py-2"
						/>
					</div>
					<button
						type="submit"
						className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
					>
						Save
					</button>
				</form>
			)}
		</div>
	);
};

export default InvestmentsTable;
